import { render } from "./OrderTableForeman.vue?vue&type=template&id=59bc9c40"
import script from "./OrderTableForeman.vue?vue&type=script&lang=js"
export * from "./OrderTableForeman.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__